import { useState, useEffect } from 'react';

const useMobileSize = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const checkMobileSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Check size on component mount
        checkMobileSize();

        // Add event listener to check size on window resize
        window.addEventListener('resize', checkMobileSize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', checkMobileSize);
        };
    }, []);

    return isMobile;
};

export default useMobileSize;
